const storageService = {
    setItemAsJSON,
    setItem,
    getItem,
    getItemAsJSON,
    clearAll,
    clearItem
    
};
function setItemAsJSON(key: string,value:any) {
    localStorage.setItem(key,JSON.stringify(value))
 }

function setItem(key: string,value:any) {
    localStorage.setItem(key, value)
}

function getItem(key: string) {
     return localStorage.getItem(key)
}
function getItemAsJSON(key: string) {
    return JSON.parse(localStorage.getItem(key) || "{}")
}

function clearAll(){
    localStorage.clear()
}

function clearItem(key:string){
    localStorage.removeItem(key)
}

 export default storageService;


 